"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core"),
    n = require("@react-pdf-viewer/attachment"),
    a = require("@react-pdf-viewer/bookmark"),
    r = require("@react-pdf-viewer/thumbnail"),
    o = require("@react-pdf-viewer/toolbar");

function c(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var a = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, a.get ? a : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var l = c(e),
    u = function u() {
  return l.createElement(t.Icon, {
    size: 16
  }, l.createElement("path", {
    d: "M11.5,1.5h11c0.552,0,1,0.448,1,1v20c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h3\n                M11.5,10.5c0,0.55-0.3,0.661-0.659,0.248L8,7.5l-2.844,3.246c-0.363,0.414-0.659,0.3-0.659-0.247v-9c0-0.552,0.448-1,1-1h5\n                c0.552,0,1,0.448,1,1L11.5,10.5z\n                M14.5,6.499h6\n                M14.5,10.499h6\n                M3.5,14.499h17\n                M3.5,18.499h16.497"
  }));
},
    _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    s = function s() {
  return l.createElement(t.Icon, {
    size: 16
  }, l.createElement("path", {
    d: "M7.618,15.345l8.666-8.666c0.78-0.812,2.071-0.838,2.883-0.058s0.838,2.071,0.058,2.883\n                c-0.019,0.02-0.038,0.039-0.058,0.058L7.461,21.305c-1.593,1.593-4.175,1.592-5.767,0s-1.592-4.175,0-5.767c0,0,0,0,0,0\n                L13.928,3.305c2.189-2.19,5.739-2.19,7.929-0.001s2.19,5.739,0,7.929l0,0L13.192,19.9"
  }));
},
    f = function f() {
  return l.createElement(t.Icon, {
    size: 16
  }, l.createElement("path", {
    d: "M10.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n                M23.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n                M10.5,22.5 c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z\n                M23.5,22.5c0,0.552-0.448,1-1,1 h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z"
  }));
},
    m = {
  left: 8,
  top: 0
},
    d = function d(e) {
  var n = e.attachmentTabContent,
      a = e.bookmarkTabContent,
      r = e.store,
      o = e.thumbnailTabContent,
      c = e.tabs,
      i = l.useContext(t.LocalizationContext),
      d = l.useState(!1),
      b = d[0],
      h = d[1],
      v = l.useState(r.get("currentTab") || 0),
      p = v[0],
      E = v[1],
      y = [{
    content: o,
    icon: l.createElement(f, null),
    title: l.createElement(l.Fragment, null, i && i.defaultLayout ? i.defaultLayout.thumbnail : "Thumbnail")
  }, {
    content: a,
    icon: l.createElement(u, null),
    title: l.createElement(l.Fragment, null, i && i.defaultLayout ? i.defaultLayout.bookmark : "Bookmark")
  }, {
    content: n,
    icon: l.createElement(s, null),
    title: l.createElement(l.Fragment, null, i && i.defaultLayout ? i.defaultLayout.attachment : "Attachment")
  }],
      g = c ? c(y) : y,
      T = function T(e) {
    p === e ? h(function (e) {
      return !e;
    }) : (h(!0), E(e));
  };

  return l.useEffect(function () {
    return r.subscribe("currentTab", T), function () {
      r.unsubscribe("currentTab", T);
    };
  }, []), l.createElement("div", {
    className: "rpv-default-layout-sidebar " + (b ? "rpv-default-layout-sidebar-opened" : "")
  }, l.createElement("div", {
    className: "rpv-default-layout-sidebar-tabs"
  }, l.createElement("div", {
    className: "rpv-default-layout-sidebar-headers"
  }, g.map(function (e, n) {
    return l.createElement("div", {
      key: n,
      className: "rpv-default-layout-sidebar-header"
    }, l.createElement(t.Tooltip, {
      position: t.Position.RightCenter,
      target: l.createElement(t.Button, {
        onClick: function onClick() {
          return T(n);
        },
        isSelected: p === n
      }, e.icon),
      content: function content() {
        return e.title;
      },
      offset: m
    }));
  })), l.createElement("div", {
    className: "rpv-default-layout-sidebar-content " + (b ? "rpv-default-layout-sidebar-content-opened" : "")
  }, g[p].content)));
};

exports.BookmarkIcon = u, exports.FileIcon = s, exports.ThumbnailIcon = f, exports.defaultLayoutPlugin = function (e) {
  var c = l.useMemo(function () {
    return t.createStore({
      currentTab: 0
    });
  }, []),
      u = n.attachmentPlugin(),
      s = a.bookmarkPlugin(),
      f = r.thumbnailPlugin(),
      m = o.toolbarPlugin(e ? e.toolbarPlugin : {}),
      b = u.Attachments,
      h = s.Bookmarks,
      v = f.Thumbnails,
      p = m.Toolbar,
      E = e ? e.sidebarTabs : function (e) {
    return e;
  },
      y = [u, s, f, m];
  return {
    attachmentPluginInstance: u,
    bookmarkPluginInstance: s,
    thumbnailPluginInstance: f,
    toolbarPluginInstance: m,
    activateTab: function activateTab(e) {
      c.update("currentTab", e);
    },
    install: function install(e) {
      y.forEach(function (t) {
        t.install && t.install(e);
      });
    },
    renderViewer: function renderViewer(t) {
      var n = t.slot;
      y.forEach(function (e) {
        e.renderViewer && (n = e.renderViewer(_i(_i({}, t), {
          slot: n
        })));
      });
      var a = n.subSlot && n.subSlot.attrs ? {
        ref: n.subSlot.attrs.ref,
        style: n.subSlot.attrs.style
      } : {};
      return n.children = l.createElement("div", {
        className: "rpv-default-layout-container"
      }, l.createElement("div", {
        className: "rpv-default-layout-toolbar"
      }, e && e.renderToolbar ? e.renderToolbar(p) : l.createElement(p, null)), l.createElement("div", {
        className: "rpv-default-layout-main"
      }, l.createElement(d, {
        attachmentTabContent: l.createElement(b, null),
        bookmarkTabContent: l.createElement(h, null),
        store: c,
        thumbnailTabContent: l.createElement(v, null),
        tabs: E
      }), l.createElement("div", _i({
        className: "rpv-default-layout-body"
      }, a), n.subSlot.children)), n.children), n.subSlot.attrs = {}, n.subSlot.children = l.createElement(l.Fragment, null), n;
    },
    uninstall: function uninstall(e) {
      y.forEach(function (t) {
        t.uninstall && t.uninstall(e);
      });
    },
    onDocumentLoad: function onDocumentLoad(e) {
      y.forEach(function (t) {
        t.onDocumentLoad && t.onDocumentLoad(e);
      });
    },
    onTextLayerRender: function onTextLayerRender(e) {
      y.forEach(function (t) {
        t.onTextLayerRender && t.onTextLayerRender(e);
      });
    },
    onViewerStateChange: function onViewerStateChange(e) {
      var t = e;
      return y.forEach(function (e) {
        e.onViewerStateChange && (t = e.onViewerStateChange(t));
      }), t;
    }
  };
};